import React from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';

function SocialIcons() {
    const elements = [
        {
            url: 'https://www.facebook.com/smetalbauru',
            icon: <FaFacebookF />,
            description: 'Facebook do Sindicato dos Metalúrgicos de Bauru'
        },
        {
            url: 'https://www.instagram.com/metalbauru',
            icon: <FaInstagram />,
            description: 'Instagram do Sindicato dos Metalúrgicos de Bauru'
        },
    ];

    return (
        <div className="d-flex gap-2">
            {elements.map((element, index) => (
                <a
                    key={index}
                    href={element.url}
                    target='_blank'
                    rel='noreferrer'
                    aria-label={element.description}
                    className="social-icon-link"
                >
                    {element.icon}
                </a>
            ))}
        </div>
    );
}

export default SocialIcons;
